import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";
import { Row, Col, Spin } from 'antd';
import BarChartComponent from '../Charts/BarChartComponent';

const PerformanceMetrics = ({ onDrillDown }) => {
    const { t } = useTranslation();
    const { performance, loadingPerformance } = useSelector((state) => state.analytics);

    if (loadingPerformance) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', padding: '60px 0' }}>
                <Spin size="large" />
            </div>
        );
    }

    // Transform data with userId for drill-down
    const winRateData = performance?.fullData?.map(item => ({
        userName: item.userName,
        winRate: item.totalDeals > 0 ? (item.wonDeals / item.totalDeals) * 100 : 0,
        userId: item.userId
    })) || [];

    const lostByOwnerData = performance?.fullData?.map(item => ({
        userName: item.userName,
        lostDeals: item.lostDeals,
        userId: item.userId
    })) || [];

    const avgDealValueData = performance?.fullData?.map(item => ({
        userName: item.userName,
        averageValue: item.totalDeals > 0 ? (item.totalScholarship / item.totalDeals) : 0,
        userId: item.userId
    })) || [];

    return (
        <div>
            <Row gutter={[16, 16]}>
                {/* Win Rate by User */}
                <Col span={12}>
                    <BarChartComponent
                        data={winRateData}
                        xAxisKey="userName"
                        yAxisKey="winRate"
                        title={t('analytics.winRateByUser')}
                        color="#10b981"
                        loading={loadingPerformance}
                        onClick={(data) => {
                            if (data && data.activeLabel) {
                                const item = performance?.fullData?.find(d => d.userName === data.activeLabel);
                                onDrillDown(`${t('analytics.winRateByUser')} - ${data.activeLabel}`, "deals", { dealOwnerId: item?.userId, reviewStatus: 'reviewed' }, item?.wonDealsRecords);
                            }
                        }}
                    />
                </Col>

                {/* Deals Lost by Owner */}
                <Col span={12}>
                    <BarChartComponent
                        data={lostByOwnerData}
                        xAxisKey="userName"
                        yAxisKey="lostDeals"
                        title={t('analytics.dealsLostByOwner')}
                        color="#ef4444"
                        loading={loadingPerformance}
                        onClick={(data) => {
                            if (data && data.activeLabel) {
                                const item = performance?.fullData?.find(d => d.userName === data.activeLabel);
                                onDrillDown(`${t('analytics.dealsLostByOwner')} - ${data.activeLabel}`, "deals", { dealOwnerId: item?.userId, reviewStatus: 'pending_review' }, item?.lostDealsRecords);
                            }
                        }}
                    />
                </Col>

                {/* Average Deal Value by User */}
                <Col span={24}>
                    <BarChartComponent
                        data={avgDealValueData}
                        xAxisKey="userName"
                        yAxisKey="averageValue"
                        title={t('analytics.avgDealValueByUser')}
                        color="#3b82f6"
                        loading={loadingPerformance}
                        height={400}
                        onClick={(data) => {
                            if (data && data.activeLabel) {
                                const item = performance?.fullData?.find(d => d.userName === data.activeLabel);
                                onDrillDown(`${t('analytics.avgDealValueByUser')} - ${data.activeLabel}`, "deals", { dealOwnerId: item?.userId }, item?.allDealsRecords);
                            }
                        }}
                    />
                </Col>
            </Row>
        </div>
    );
};

export default PerformanceMetrics;
